import InputField from "components/input-field/input-field.component";
import Selector from "components/selector/selector.component";
import Toggle from "components/toggle/toggle.component";
import LanguageSelector from "components/topbar/language-selector/language-selector.component";
import useTranslate from "src/hooks/use-translate";
import "./settings.style.scss";

const Settings = () => {
	const t = useTranslate("Account");

	return (
		<div className="settings-container">
			<span className="with-line size600 w600">{t("settings")}</span>
			<div className="data-wrapper scroll-bar scroll-bar--overflow">
				<div name="profile" className="block">
					<p className="size500 w600 with-line">{t("profile")}</p>
					<p className="size400  w600 margin-m--top">{t("change job title")}</p>
					<p className="size300  margin-s--top margin-l--bottom">
						{t("change your job title based on the updates in your career path in your company.")}
					</p>
					<InputField type="text" placeholder={"current job title"} />
					<p className="size400  w600 margin-m--top">{t("change contact information")}</p>
					<p className="size300  margin-s--top margin-l--bottom">
						{t(
							"change contact information based on the recent changes in your phone number or email address."
						)}
					</p>

					<div className="inputs gap-s">
						<span className="grid">
							<p>{t("phone")}</p>
							<InputField type="text" placeholder={"phone number"} />
						</span>
						<span className="grid">
							<p>{t("email")}</p>
							<InputField type="text" placeholder={"email address"} />
						</span>
						<button className="btn">{t("save")}</button>
					</div>
				</div>
				<div name="password" className="block">
					<p className="size500 w600 with-line">{t("password")}</p>
					<p className="size400  w600 margin-m--top">{t("change Password")}</p>
					<p className="size300  margin-s--top margin-l--bottom">
						{t(
							"use a password at least 8 characters long which includes letters, numbers, and symbols"
						)}
					</p>
					<div className="inputs gap-s">
						<InputField type="password" placeholder={"current password"} />
						<InputField type="password" placeholder={"new password"} />
						<InputField type="password" placeholder={"confirm new password"} />
						<button className="btn">{t("save")}</button>
					</div>
				</div>
				<div name="notifications" className="block">
					<div className="size500 w600 with-line">{t("notifications")}</div>
					<div className="flex flex--center-items">
						<div className="flex--grow">
							<p className="size400  w600 margin-m--top">{t("mobile Push Notifications")}</p>
							<p className="size300  margin-s--top margin-l--bottom">
								{t("receive push notifications on messages and reminders via your mobile app.")}
							</p>
						</div>
						<Toggle />
					</div>
					<div className="flex flex--center-items">
						<div className="flex--grow">
							<p className="size400  w600 margin-m--top">{t("desktop Push Notifications")}</p>
							<p className="size300  margin-s--top margin-l--bottom">
								{t(
									"receive push notifications on messages and reminders immediately via your desktop app."
								)}
							</p>
						</div>
						<Toggle />
					</div>
					<div className="flex flex--center-items ">
						<div className="flex--grow">
							<p className="size400  w600 margin-m--top">{t("email Push Notifications")}</p>
							<p className="size300  margin-s--top margin-l--bottom">
								{t("receive email updates on messages and reminders.")}
							</p>
						</div>
						<Toggle />
					</div>
				</div>
				<div name="preferences" className="block">
					<p className="size500 w600 with-line">{t("preferences")}</p>
					<div className="flex flex--center-items">
						<div className="flex--grow">
							<p className="size400  w600 margin-m--top">{t("langugage")}</p>
							<p className="size300  margin-s--top margin-l--bottom">
								{t("change the language used in the user interface.")}
							</p>
						</div>
						<LanguageSelector />
					</div>
					<div className="flex flex--center-items">
						<div className="flex--grow">
							<p className="size400 w600 margin-m--top">{t("appearance")}</p>
							<p className="size300 margin-s--top margin-l--bottom">
								{t("customize how METI Box looks on your device.")}
							</p>
						</div>
						<div style={{ width: 100 }}>
							<Selector data={["Light", "Dark"]} onSelected={() => {}} />
						</div>
					</div>
					{/* <p className="size400  w600 margin-m--top">Cookie Settings</p>
					<p className="size300  margin-s--top margin-l--bottom">Customize cookies.</p> */}
				</div>
			</div>
		</div>
	);
};

export default Settings;
